export default {
  pages: {
    key: "meta",
    data: [
      { title: 'Home', url: '/', icon: 'HomeIcon', is_bookmarked: false, i18n: 'Home', meta: 'Home Accueil' },
      {
        title: 'Cashflow',
        url: '/bsg/cashflow',
        icon: "DollarSignIcon",
        is_bookmarked: false,
        i18n: 'CashFlow.Title',
        meta: 'Cashflow Cash Flow ',
        requireRoles: [
          'CashflowReaders',
          'CashflowWriter',
          'Admin'
        ]
      },
      {
        title: 'Project Loms', 
        url: '/bsg/cashflow/projectLoms', 
        icon: "CalendarIcon", 
        is_bookmarked: false, 
        i18n: 'CashFlow.ProjectLom.Title',
        meta: 'Project Projets Loms', 
        requireRoles: [
          'CashflowWriter',
          'Admin'
        ]
      },
      { 
        title: 'Corporate Loms', 
        url: '/bsg/cashflow/corporateLoms', 
        icon: "CalendarIcon", 
        is_bookmarked: false, 
        i18n: 'CashFlow.CorporateLom.Title', 
        meta: 'Corporate Corporatif Loms',  
        requireRoles: [
          'CashflowWriter',
          'Admin'
        ] 
      },
      { 
        title: 'Compilations', 
        url: '/bsg/cashflow/compilations', 
        icon: "FilmIcon", 
        is_bookmarked: false, 
        i18n: 'CashFlow.Compilation.Title', 
        meta: 'Compilations Compilations',
        requireRoles: [
          'CashflowWriter',
          'Admin'
        ]
      },
      { 
        title: 'Reports', 
        url: '/bsg/cashflow/reports', 
        icon: "TrendingUpIcon", 
        is_bookmarked: false, 
        i18n: 'CashFlow.Reports.Title',
        meta: 'Reports Rapports',
        requireRoles: [
          'CashflowWriter',
          'Admin'
        ]
      },
      { 
        title: 'Admin', 
        url: '/bsg/cashflow/admin', 
        icon: "LockIcon", 
        is_bookmarked: false, 
        i18n: 'CashFlow.Admin.Title', 
        meta: 'Admin',
        requireRoles: [
          'CashflowWriter',
          'Admin'
        ]
      },
      { 
        title: 'Regions', 
        url: '/bsg/cashflow/admin/regions', 
        icon: "MapIcon", 
        is_bookmarked: false, 
        i18n: 'CashFlow.Region.Title', 
        meta: 'Regions Régions',
        requireRoles: [
          'CashflowWriter',
          'Admin'
        ]
      },
      { 
        title: 'Projects', 
        url: '/bsg/cashflow/admin/projects', 
        icon: "EditIcon", 
        is_bookmarked: false, 
        i18n: 'CashFlow.Project.Title', 
        meta: 'Projects Projets',
        requireRoles: [
          'CashflowWriter',
          'Admin'
        ]
      },
      { 
        title: 'Scenarios', 
        url: '/bsg/geo/scenarios', 
        icon: "FilmIcon", 
        is_bookmarked: false, 
        i18n: 'GeoScenarioPage.Title', 
        meta: 'Scenarios',
        requireRoles: [
          'GeoReaders',
          'Admin'
        ]
      },
      { 
        title: 'NSR', 
        url: '/geo/nsr', 
        icon: "DollarSignIcon", 
        is_bookmarked: false, 
        i18n: 'Geo.NSR.Title', 
        meta: 'NSR Net Smelting Revenue',
        requireRoles: [
          'GeoWriters',
          'Admin'
        ]
      },
      { 
        title: 'Geo stats', 
        url: '/geo/geostats', 
        icon: "TrendingUpIcon", 
        is_bookmarked: false, 
        i18n: 'Geo.QAQC.Title', 
        meta: 'Geo stats',
        requireRoles: [
          'GeoReaders',
          'Admin'
        ]
      },
      { 
        title: 'Contrôle de la teneur', 
        url: '/geo/gradecontrol', 
        icon: "LayersIcon", 
        is_bookmarked: false, 
        i18n: 'GradeControl.Title', 
        meta: 'Grade Control Contrôle de la teneur',
        requireRoles: [
          'GradeControlReaders',
          'Admin'
        ]
      },
      { 
        title: 'Timesheet', 
        url: '/geo/gradecontrol/timesheet', 
        icon: "ClockIcon", 
        is_bookmarked: false, 
        i18n: 'GradeControl.Timesheet.Title', 
        meta: 'Timesheet Feuille de temps',
        requireRoles: [
          'GradeControlCollaborators',
          'Admin'
        ]
      },
      { 
        title: 'Samples', 
        url: '/geo/gradecontrol/samples', 
        icon: "ShoppingBagIcon", 
        is_bookmarked: false, 
        i18n: 'GradeControl.Sample.LIMSTitle', 
        meta: 'Samples Échantillons Echantillons',
        requireRoles: [
          'SamplesWriters',
          'Admin'
        ]
      },
      { 
        title: 'Forecast', 
        url: '/geo/gradecontrol/forecast', 
        icon: "EyeIcon", 
        is_bookmarked: false, 
        i18n: 'GradeControl.Forecast.Title', 
        meta: 'Forecast Prévisions Previsions',
        requireRoles: [
          'GradeControlCollaborators',
          'Admin'
        ]
      },
      { 
        title: 'Production Summary', 
        url: '/geo/gradecontrol/productionSummary', 
        icon: "TruckIcon", 
        is_bookmarked: false, 
        i18n: 'GradeControl.ProductionSummary.Title', 
        meta: 'Production Summary Sommaire de production',
        requireRoles: [
          'GradeControlReaders',
          'GradeControlCollaborators',
          'Admin'
        ]
      },
      { 
        title: 'Monthly Summary', 
        url: '/geo/gradecontrol/monthlySummary', 
        icon: "TargetIcon", 
        is_bookmarked: false, 
        i18n: 'GradeControl.MonthlySummary.Title', 
        meta: 'Monthly Summary Sommaire Mensuel Mois',
        requireRoles: [
          'GradeControlReaders',
          'GradeControlCollaborators',
          'Admin'
        ]
      },
      { 
        title: 'Posting', 
        url: '/geo/gradecontrol/posting', 
        icon: "TCheckCircleIcon",
        is_bookmarked: false, 
        i18n: 'GradeControl.Posting.Title', 
        meta: 'Posting Month Fermeture Mois',
        requireRoles: [
          'GradeControlCollaborators',
          'Admin'
        ]
      },
      { 
        title: 'Reports', 
        url: '/geo/gradecontrol/reports', 
        icon: "TrendingUpIcon", 
        is_bookmarked: false, 
        i18n: 'GradeControl.Reports.Title', 
        meta: 'Reports Rapports',
        requireRoles: [
          'GeoReaders',
          'Admin'
        ]
      },
      { 
        title: 'Admin', 
        url: '/geo/gradecontrol/admin', 
        icon: "LockIcon", 
        is_bookmarked: false, 
        i18n: 'GradeControl.Admin.Title', 
        meta: 'Admin',
        requireRoles: [
          'GeoReaders',
          'Admin'
        ]
      },
      { 
        title: 'Locations', 
        url: '/geo/gradecontrol/admin/locations', 
        icon: "LockIcon", 
        is_bookmarked: false, 
        i18n: 'GradeControl.Location.Title', 
        meta: 'Locations Emplacements',
        requireRoles: [
          'GradeControlCollaborators',
          'Admin'
        ]
      },
      { 
        title: 'Equipments', 
        url: '/geo/gradecontrol/admin/equipments', 
        icon: "LockIcon", 
        is_bookmarked: false, 
        i18n: 'GradeControl.Equipment.Title', 
        meta: 'Equipments Équipements Equipement',
        requireRoles: [
          'GradeControlCollaborators',
          'Admin'
        ]
      },
      { 
        title: 'Muck Types', 
        url: '/geo/gradecontrol/admin/mucktypes', 
        icon: "LockIcon", 
        is_bookmarked: false, 
        i18n: 'GradeControl.MuckType.Title', 
        meta: 'Type de muck type',
        requireRoles: [
          'GradeControlCollaborators',
          'Admin'
        ]
      },
      { 
        title: 'Drilling', 
        url: '/drilling', 
        icon: "CrosshairIcon", 
        is_bookmarked: false, 
        i18n: 'Drilling.MainTitle', 
        meta: 'Drilling Forage',
        requireRoles: [
          'DrillingReaders',
          'DrillingWriters',
          'Admin'
        ]
      }
    ]
  }
}
